import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (emailTemplateId: ID) => {
  return {
    endpoint: `/email_templates/${emailTemplateId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
